import axios from "axios";
export const API_URL = "/api/v1";
// export const CONTACT_URL = API_URL+"/contact_board/";
export const CONTACT_URL = API_URL+"/contact_board/write_contact/";
export const STORE_ENTRY_CONTACT_URL = API_URL+"/contact_board/write_store_entry_contact/";
export const GET_COMPANY_URL = API_URL+"/contract/get_company_list";
export const GET_TREATMENT_COMPANY_URL = API_URL+"/contract/get_treatment_company_list";
export const GET_MY_TREATMENT_COMPANY_URL = API_URL+"/contract_company_group/my_company_contracted_company_unique/";
export const WRITE_CLIENT_URL = API_URL+"/contract/write_client_data/";
export const DELETE_CLIENT_URL = API_URL+"/contract/delete_client_data/";
export const GET_CONTRACT_COMPANY_LIST_URL = API_URL+"/contract/get_contract_company_list/";
export const GET_CONTRACT_COMPANY_LIST_FOR_TREATMENT_URL = API_URL+"/contract/get_contract_company_for_treatment_list/";
export const GET_CLIENT_DETAIL_DATA_URL = API_URL+"/contract/get_client_detail_data/";
export const EDIT_CLIENT_URL = API_URL+"/contract/update_client_data/";
export const UPDATE_CONTRACT_DATA_FOR_TREATMENT = API_URL+"/contract/update_contract_data_for_treatment/";


export function saveContactData(data) {
  return axios.post(CONTACT_URL, data);
}

export function saveStoreEntryContactData(fd) {
  return axios.post(STORE_ENTRY_CONTACT_URL, fd, {headers : {'Content-Type' : 'multipart/form-data'}});
}

export function getCompanyList() {
  return axios.get(GET_COMPANY_URL);
}

export function getTreatmentCompanyList(contract_id) {
  return axios.get(GET_TREATMENT_COMPANY_URL + '?contract_id=' + contract_id);
}

export function getMyTreatmentCompanyList(params) {
  return axios.get(GET_MY_TREATMENT_COMPANY_URL + '?id=' + params.driver_company_id + '&company_type=treatment');
}

export function saveClientData(data) {
  return axios.post(WRITE_CLIENT_URL, data);
}

export function getContractCompanyList(params) {
  return axios.get(GET_CONTRACT_COMPANY_LIST_URL + '?page=' +params.page+'&company_name=' + params.company_name + '&company_number=' + params.company_number + '&cms_number=' + params.cms_number + '&emitter_type=' + params.emitter_type + '&client_type=' + params.client_type + '&settlement_date=' + params.settlement_date + '&car=' + params.car + '&collect_zone=' + params.collect_zone + '&receipt_type=' + params.receipt_type);
}

export function getContractCompanyForTreatmentList(params) {
  return axios.get(GET_CONTRACT_COMPANY_LIST_FOR_TREATMENT_URL + '?page=' +params.page+'&company_name=' + params.company_name + '&company_number=' + params.company_number);
}

export function deleteClientData(params) {
  return axios.post(DELETE_CLIENT_URL, params);
}

export function getClientDetailData(params) {
  return axios.get(GET_CLIENT_DETAIL_DATA_URL + '?company=' + params.company + '&contract=' + params.contract);
}

export function updateClientData(data) {
  return axios.post(EDIT_CLIENT_URL, data);
}

export function updateContractDataForTreatment(params) {
  return axios.post(UPDATE_CONTRACT_DATA_FOR_TREATMENT, params);
}
